// Derives a clickable trail from the current router state. Strings
// hard-coded path segments by mapping pathname pieces into labels;
// dynamic segments ($accountSlug etc.) render as the raw segment
// value. Mount inside a page header or just below the global one.

import { Link, useMatches } from "@tanstack/react-router";

export function Breadcrumbs() {
  const matches = useMatches();
  // Drop the root match (id: "__root__") since it has no path of its own.
  const crumbs = matches
    .filter((m) => m.pathname && m.pathname !== "/")
    .map((m) => ({ to: m.pathname, label: lastSegmentLabel(m.pathname) }));

  if (crumbs.length === 0) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        display: "flex",
        gap: 6,
        flexWrap: "wrap",
        color: "var(--text-dim)",
        fontSize: "0.8rem",
        marginBottom: 12,
      }}
    >
      {crumbs.map((crumb, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <span key={crumb.to} style={{ display: "inline-flex", gap: 6 }}>
            {!isLast ? (
              <Link
                to={crumb.to}
                style={{ color: "var(--text-dim)", textDecoration: "none" }}
              >
                {crumb.label}
              </Link>
            ) : (
              <span style={{ color: "var(--text)" }}>{crumb.label}</span>
            )}
            {!isLast && <span aria-hidden>/</span>}
          </span>
        );
      })}
    </nav>
  );
}

function lastSegmentLabel(pathname: string): string {
  const parts = pathname.replace(/^\/+|\/+$/g, "").split("/");
  return parts[parts.length - 1] || pathname;
}
